<template>
  <div class="meal-nutrients">
    <template v-if="day && day.dishesAndIngredients.length > 0">
      <div class="meal-nutrients__header meal-nutrients__name" :title="`${day.calories} kcal`">
        {{ day.calories }}
        kcal
      </div>
      <div class="meal-nutrients__header meal-nutrients__value" :title="`${day.quantity} g`">
        {{ day.quantity }}
        g
      </div>
      <template v-for="(value, key) in day.nutrients" :key="`${key}-name`">
        <div class="meal-nutrients__name" :title="`${nutrientsMap[key].shortcut}`">
          {{ nutrientsMap[key].shortcut }}
        </div>
        <div class="meal-nutrients__value" :title="`${value} ${nutrientsMap[key].measurement}`">
          {{ value }}
          {{ nutrientsMap[key].measurement }}
        </div>
      </template>
    </template>
  </div>
</template>

<script setup lang="ts">
  import type { PropType } from 'vue'

  import { nutrientsMap } from '@/utils/nutrients'

  import type { ScheduleMealDay } from '@/types/Diet'

  defineProps({
    day: {
      type: Object as PropType<ScheduleMealDay>,
    },
  })
</script>
<style scoped>
  .meal-nutrients {
    display: flex;
    flex-wrap: wrap;
    place-content: flex-start space-between;
    width: 160px;
    min-width: 160px;
    margin-left: 9px;
  }

  .meal-nutrients__name {
    width: 80px;
  }

  .meal-nutrients__value {
    width: 76px;
    margin-left: 4px;
  }

  .meal-nutrients__name,
  .meal-nutrients__value {
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 12px;
    line-height: 15px;
    text-align: right;
    white-space: nowrap;
    cursor: default;
  }

  .meal-nutrients__header {
    margin-bottom: 10px;
    font-family: Montserrat-SemiBold;
  }
</style>
